/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const FilterLines = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		className="pum-icon pum-icon--filter-lines"
	>
		<Path
			d="M6.5 12H16.5M4 7H19M9 17H14"
			stroke="#000000"
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SVG>
);

export default FilterLines;
